export type Tone = 'primary' | 'accent' | 'secondary';

export const toneStyles: Record<
  Tone,
  { iconBox: string; chip: string; bar: string; hoverBorder: string; dot: string }
> = {
  primary: {
    iconBox: 'bg-primary-100 text-primary-700',
    chip: 'bg-primary-100 text-primary-800',
    bar: 'bg-primary-500',
    hoverBorder: 'hover:border-primary-300',
    dot: 'bg-primary-500',
  },
  accent: {
    iconBox: 'bg-accent-100 text-accent-800',
    chip: 'bg-accent-100 text-accent-900',
    bar: 'bg-accent-500',
    hoverBorder: 'hover:border-accent-300',
    dot: 'bg-accent-500',
  },
  secondary: {
    iconBox: 'bg-secondary-100 text-secondary-800',
    chip: 'bg-secondary-100 text-secondary-900',
    bar: 'bg-secondary-500',
    hoverBorder: 'hover:border-secondary-300',
    dot: 'bg-secondary-500',
  },
};

export function resolveTone(tone: string): Tone {
  if (tone === 'accent' || tone === 'secondary') return tone;
  return 'primary';
}